module.exports = __webpack_public_path__ + "img/wechat_code1.947d49b0.png";